import { MessageModel } from "./option/message.model";
import { MessageService } from "./message.service";
import { ToastrService, ActiveToast, IndividualConfig } from "ngx-toastr";
import { EMessageLevel } from "./option/message-level.e";
import { Injectable, Renderer2 } from "@angular/core";
import { AppUtils } from "../utils/app-utils";

@Injectable()
export class DefaultMessageService implements MessageService {
	constructor(public toast: ToastrService) {
		if (AppUtils.isMobileApp) {
			toast.toastrConfig.positionClass = "toast-bottom-center";
		}
	}

	public present(
		message: MessageModel,
		level?: EMessageLevel
	): ActiveToast<any> {
		let toastInst: ActiveToast<any> = null;
		const opts: Partial<IndividualConfig> = {
			disableTimeOut: message.freeze,
			positionClass: message.class,
			tapToDismiss: message.tabDismiss
		};
		switch (level) {
			case EMessageLevel.ERROR:
				toastInst = this.toast.error(message.content, null, opts);
			case EMessageLevel.WARNING:
				toastInst = this.toast.warning(message.content, null, opts);
			case EMessageLevel.SUCCESS:
				toastInst = this.toast.success(message.content, null, opts);
			case EMessageLevel.INFO:
				toastInst = this.toast.info(message.content, null, opts);
			default:
				toastInst = this.toast.show(message.content, null, opts);
		}

		this.toggleOverlayContainer(true);

		return toastInst;
	}

	public dismiss(messageId: number) {
		this.toast.remove(messageId);
		// Work arround, remove dirty html after close toast
		this.toggleOverlayContainer(false);
	}

	private toggleOverlayContainer(flag) {
		// Work arround, remove dirty html after close toast
		const dirtyHtml = document.getElementsByClassName("overlay-container");
		if (dirtyHtml && dirtyHtml.length > 0) {
			dirtyHtml[0].classList.remove(flag ? "d-none" : "d-block");
			dirtyHtml[0].classList.add(!flag ? "d-none" : "d-block");
		}
	}
}
